import React from "react";
import { ProductPreview } from "./design/ProductPreview";
import { formatEuro } from "../utils/pricing";
import type { Configurator } from "../hooks/useConfigurator";
interface OrderSummaryProps {
  config: Configurator;
}
export function OrderSummary({
  config
}: OrderSummaryProps) {
  const {
    product,
    color,
    marking,
    mockup,
    design,
    state,
    quote
  } = config;
  if (!product || !quote || !mockup || !color) return null;
  const usedZones = mockup.zones.filter(z => design.elements.some(e => e.zoneId === z.id));
  const view = usedZones[0]?.view ?? "front";
  const rows: [string, string][] = [["Couleur", color.name], ["Quantité", `${state.quantity} pcs`], ["Marquage", marking?.name ?? "—"], ["Emplacements", usedZones.length ? usedZones.map(z => z.name).join(", ") : "À définir"]];
  return <aside aria-label="Votre configuration" className="border border-line" data-id="element-101" data-mp="2ltrarqno378j">
      <ProductPreview mockupId={mockup.id} hex={color.hex} view={view} elements={design.elements} markingId={marking?.id ?? null} className="w-full border-b border-line" data-id="element-102" data-mp="2gvpvlgtd3s2c" />
      <div className="p-5" data-id="element-103" data-mp="1cz6g3hsl0mkb">
        <p className="text-xs text-muted" data-id="element-104" data-mp="1cv8wkv23dszw">{product.ref}</p>
        <p className="mt-1 text-lg font-bold leading-tight" data-id="element-105" data-mp="yz5fm3g8bh5d">{product.name}</p>
        <dl className="mt-4" data-id="element-106" data-mp="13w5cbnr6v7jt">
          {rows.map(([k, v]) => <div key={k} className="flex justify-between gap-3 border-t border-ink/15 py-2 text-sm" data-id="element-107" data-mp="1rmhsflwl8alh">
              <dt className="shrink-0 text-muted" data-id="element-108" data-mp="1vo3b5nvszj3l">{k}</dt>
              <dd className="truncate text-right font-bold" data-id="element-109" data-mp="1vnl7w7aq44m6">{v}</dd>
            </div>)}
        </dl>
      </div>
      <div className="border-t border-line bg-mint p-5" data-id="element-110" data-mp="1hulrm334a6dk">
        <p className="text-xs font-bold" data-id="element-111" data-mp="1murdf2mpgynq">Estimation HT</p>
        <p className="text-3xl font-bold tabular-nums" data-id="element-112" data-mp="2aldkorovyewo">{formatEuro(quote.total)}</p>
        <p className="text-sm" data-id="element-113" data-mp="2ajamhkdkxfgv">{formatEuro(quote.unitTotal)} / pièce · calage inclus</p>
      </div>
    </aside>;
}